import { render } from "./BuySellPressure.vue?vue&type=template&id=310a2742&scoped=true"
import script from "./BuySellPressure.vue?vue&type=script&lang=js"
export * from "./BuySellPressure.vue?vue&type=script&lang=js"

import "./BuySellPressure.vue?vue&type=style&index=0&id=310a2742&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310a2742"],['__file',"resources/js/components/BuySellPressure.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "310a2742"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('310a2742', __exports__)) {
    api.reload('310a2742', __exports__)
  }
  
  module.hot.accept("./BuySellPressure.vue?vue&type=template&id=310a2742&scoped=true", () => {
    api.rerender('310a2742', render)
  })

}


export default __exports__